import qs from 'qs';
import axios from 'axios';
import store from '@/store';


function getTotalPlay(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/summary/total-play${query}`);
}

function getTotalWatchDuration(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/summary/total-watch-duration${query}`);
}

function getTopVideosSortedByFilter(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/summary/top-videos${query}`);
}

export {
  getTotalPlay,
  getTotalWatchDuration,
  getTopVideosSortedByFilter,
};
